import React from 'react';
import BlurSkeleton from './BlurSkeleton';
import SkeletonRegion from './SkeletonRegion';
import { useStyles } from './MapPageSkeleton.styles';

const MapPageSkeleton = () => {
  const classes = useStyles();
  return (
    <div className="page-content">
      <SkeletonRegion className={classes.skeletonContainer}>
        <BlurSkeleton variant="rect" className={classes.MapHeader} />
        <div className={classes.mapInfoContainer}>
          <BlurSkeleton variant="rect" className={classes.mapInfoDiv} delay={120} />
          <BlurSkeleton variant="rect" className={classes.MapHeaderButton} delay={200} />
        </div>
        <div className={classes.mapContainer}>
          <BlurSkeleton variant="rect" className={classes.mapDiv} delay={280} />
          <BlurSkeleton variant="rect" className={classes.stationInfoDiv} delay={360} />
        </div>
      </SkeletonRegion>
    </div>
  );
};

export default MapPageSkeleton;
